<script setup>

import WithNotification from "@/Layouts/WithNotification.vue";
import NavMenuTop from "@/Components/UI/nav/NavMenuTop.vue";
import WithFavicon from "@/Components/WithFavicon.vue";
import HandlePropsNotifications from "@/Layouts/HandlePropsNotifications.vue";
</script>

<template>
    <WithFavicon/>
    <NavMenuTop/>
    <HandlePropsNotifications/>
    <WithNotification left="left-0">
        <main>
            <div class="pt-32 pb-10 min-h-screen px-5 md:px-10">
                <div class="mt-10 md:p-10">
                    <slot/>
                </div>
            </div>
        </main>
    </WithNotification>
</template>

<style scoped>
@media (min-width: 768px) {
    main {
        background-image: url("/storage/images/public-layout-bg.svg");
        background-size: cover;
        background-repeat: no-repeat;
        object-fit: cover;
    }
}
</style>
